import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PROMO_BANNER_COUNTDOWN_FLAG_NAME } from '../constants'

/**
 * Fires Experiment Viewed for both arms once the visitor is inside the countdown window.
 *
 * Takes eligibility as an argument rather than reading it itself so the caller's single
 * `useExperiment` call owns the only countdown ticker. It also owns the effect rather than handing
 * the caller an imperative `trackEV` (the shape the other banner experiment uses), because
 * eligibility here resolves after first render — a mount-only effect would always see false.
 * `trackExperimentViewed` dedupes internally, so re-running on change is safe.
 */
export const useTrackExperimentViewed = (isEligible: boolean) => {
  useEffect(() => {
    if (!isEligible) return

    trackExperimentViewed(PROMO_BANNER_COUNTDOWN_FLAG_NAME)
  }, [isEligible])
}
